/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Eventrequestphonelink3Inputs */

const en_eventrequestphonelink3 = /** @type {(inputs: Eventrequestphonelink3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How it works`)
};

const de_eventrequestphonelink3 = /** @type {(inputs: Eventrequestphonelink3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`So geht’s`)
};

/**
* | output |
* | --- |
* | "How it works" |
*
* @param {Eventrequestphonelink3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const eventrequestphonelink3 = /** @type {((inputs?: Eventrequestphonelink3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Eventrequestphonelink3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_eventrequestphonelink3(inputs)
	return de_eventrequestphonelink3(inputs)
});
export { eventrequestphonelink3 as "eventRequestPhoneLink" }